export default class Util {

    public static languageServer(lang: string): string {
        if ((window as any).TISearchData) {
            const TISearchData = (window as any).TISearchData;
            if (TISearchData.language_servers) {
                return TISearchData.language_servers[lang] ? TISearchData.language_servers[lang].replace(/\//g, '') : '';
            }
        }
        return '';
    }

    /**
     * Helper method to add a query string to a URL
     * @param url
     * @param queryString
     */
    public static addQueryParams(url: string, queryString: string): string {
        if (queryString) {
            // base?query#hash
            const basePart: string = url.split('?')[0].split('#')[0];
            const hashPart: string = (url.indexOf('#') < 0) ? '' : url.split('#')[1];
            let queryPart: string = (url.indexOf('?') < 0) ? '' : url.split('?')[1].split('#')[0];
            queryPart = queryPart ? `${queryPart}&${queryString}` : queryString;
            url = `${basePart}${queryPart ? '?' : ''}${queryPart}${hashPart ? '#' : ''}${hashPart}`;
        }
        return url;
    }

    /**
     * Helper method to add a query string parameter with value to a URL
     * @param url
     * @param name
     * @param value
     */
    public static addQueryParam(url: string, name: string, value: string): string {
        if (name && value != undefined) {
            return Util.addQueryParams(url, `${name}${value ? '=' : ''}${value}`)
        }
        return url;
    }

    /**
     * Helper method to remove a query string parameter from a URL
     * @param url
     * @name name
     */
    public static removeQueryParam(url: string, name: string): string {
        if (name) {
            // base?query#hash
            const basePart: string = url.split('?')[0].split('#')[0];
            const hashPart: string = (url.indexOf('#') < 0) ? '' : url.split('#')[1];
            let queryPart: string = (url.indexOf('?') < 0) ? '' : url.split('?')[1].split('#')[0];
            queryPart = queryPart.split('&').filter((p) => { return p.split('=')[0] != name; }).join('&');
            url = `${basePart}${queryPart ? '?' : ''}${queryPart}${hashPart ? '#' : ''}${hashPart}`;
        }
        return url;
    }

    /**
     * Helper method to get the value of a query string parameter in a URL
     * @param url
     * @param name
     */
    public static getQueryParam(url: string, name: string): string {
        let value: string = undefined;
        if (name && url.indexOf('?') >= 0) {
            url.split('?')[1].split('#')[0].split('&').forEach((p) => {
                const nvp: string[] = p.split('=');
                if (nvp[0] == name) value = (nvp.length > 1) ? nvp[1] : '';
            });
        }
        return value;
    }

    /**
     * Helper method to set the value of a query string parameter in a URL
     * @param url
     * @param name
     * @param value
     */
    public static setQueryParam(url: string, name: string, value: string): string {
        if (name) {
            if (Util.getQueryParam(url, name) == undefined) {
                return Util.addQueryParams(url, `${name}=${value}`);
            }
            // base?query#hash
            const basePart: string = url.split('?')[0].split('#')[0];
            const hashPart: string = (url.indexOf('#') < 0) ? '' : url.split('#')[1];
            let queryPart: string = (url.indexOf('?') < 0) ? '' : url.split('?')[1].split('#')[0];
            // update value in place
            queryPart = queryPart.split('&').map((p) => {
                const nvp: string[] = p.split('=');
                return (nvp[0] != name) ? p : (value == undefined) ? '' : `${nvp[0]}${value ? '=' : ''}${value}`;
            }).join('&');
            url = `${basePart}${queryPart ? '?' : ''}${queryPart}${hashPart ? '#' : ''}${hashPart}`;
        }
        return url;
    }

    /**
     * Helper method to add a hash string to a URL
     * @param url
     * @param queryString
     */
    public static addHashParams(url: string, hashString: string): string {
        if (hashString) {
            // base?query#hash
            const basePart: string = url.split('?')[0].split('#')[0];
            const queryPart: string = (url.indexOf('?') < 0) ? '' : url.split('?')[1].split('#')[0];
            let hashPart: string = (url.indexOf('#') < 0) ? '' : url.split('#')[1];
            hashPart = hashPart ? `${hashPart}&${hashString}` : hashString;
            url = `${basePart}${queryPart ? '?' : ''}${queryPart}${hashPart ? '#' : ''}${hashPart}`;
        }
        return url;
    }

    /**
     * Helper method to add a hash parameter with value to a URL
     * @param url
     * @param name
     * @param value
     */
    public static addHashParam(url: string, name: string, value: string): string {
        if (name && value != undefined) {
            return Util.addHashParams(url, `${name}${value ? '=' : ''}${value}`)
        }
        return url;
    }

    /**
     * Helper method to remove a hash
     * @name name
     */
    public static removeHashParam(url: string, name: string): string {
        if (name) {
            // base?query#hash
            const basePart: string = url.split('?')[0].split('#')[0];
            const queryPart: string = (url.indexOf('?') < 0) ? '' : url.split('?')[1].split('#')[0];
            let hashPart: string = (url.indexOf('#') < 0) ? '' : url.split('#')[1];
            hashPart = hashPart.split('&').filter((p) => { return p.split('=')[0] != name; }).join('&');
            url = `${basePart}${queryPart ? '?' : ''}${queryPart}${hashPart ? '#' : ''}${hashPart}`;
        }
        return url;
    }

    /**
     * Helper method to get the value of a hash parameter in a URL
     * @param url
     * @param name
     */
    public static getHashParam(url: string, name: string): string {
        let value: string = undefined;
        if (name && url.indexOf('#') >= 0) {
            url.split('#')[1].split('&').forEach((p) => {
                const nvp: string[] = p.split('=');
                if (nvp[0] == name) value = (nvp.length > 1) ? nvp[1] : '';
            });
        }
        return value;
    }

    /**
     * Helper method to set the value of a hash parameter in a URL
     * @param url
     * @param name
     * @param value
     */
    public static setHashParam(url: string, name: string, value: string): string {
        if (name) {
            if (Util.getHashParam(url, name) == undefined) {
                return Util.addHashParams(url, `${name}=${value}`);
            }
            // base?query#hash
            const basePart: string = url.split('?')[0].split('#')[0];
            const queryPart: string = (url.indexOf('?') < 0) ? '' : url.split('?')[1].split('#')[0];
            let hashPart: string = (url.indexOf('#') < 0) ? '' : url.split('#')[1];
            // update value in place
            hashPart = hashPart.split('&').map((p) => {
                const nvp: string[] = p.split('=');
                return (nvp[0] != name) ? p : (value == undefined) ? '' : `${nvp[0]}${value ? '=' : ''}${value}`;
            }).join('&');
            url = `${basePart}${queryPart ? '?' : ''}${queryPart}${hashPart ? '#' : ''}${hashPart}`;
        }
        return url;
    }

    /**
     * decode HTML characters
     * @param locale
     */
    public static decodeHtml(input): string {
        // @ts-ignore
        return input.replace(/&amp;/g, "&").replace(/&#(\d+);/g, function (match, code) {
            return String.fromCharCode(code);
        });
    }

    /**
     * Get TI 2-letter lang code from locale
     * @param locale
     */
    public static getlangFromLocale(locale: string): string {
        return locale.toLowerCase() === 'en-us' ? 'en' : locale.substr(3, 2).toLowerCase();
    }

    /**
     * Check that locale is valid. If not, return en-US default locale.
     * @param locale - the locale to validate
     * @returns String validated locale
     */
    public static getValidLocale(locale: string): string {
        return ['en-US', 'es-MX', 'de-DE', 'ja-JP', 'ko-KR', 'ru-RU', 'zh-CN', 'zh-TW'].includes(locale) ? locale : 'en-US';
    }

    /**
     * Format URL / replace template vars
     * @param url
     * @param replace
     * @param queryString
     */
    public static formatUrl(url: string, replace: object, queryString: string = ''): string {
        let formatted: string = url;
        if (queryString) {
            formatted = Util.addQueryParams(formatted, queryString);
        }
        const props = Object.getOwnPropertyNames(replace);
        props.forEach(function (prop: string) {
            const pattern: RegExp = new RegExp(`{${prop}}`, 'g');
            formatted = formatted.replace(pattern, replace[prop]);
        });
        return formatted;
    }

    public static getCookie(name, defaultValue = null) {
        const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? decodeURIComponent(v[2]) : defaultValue;
    }

    public static setCookie(name, value) {
        document.cookie = name + "=" + value + ";path=/;";
    }

    public static wait(ms: number = 1000): Promise<void> {
        return new Promise<void>(resolve => {
            setTimeout(function () { resolve(); }, ms || 1000);
        });
    };

    public static async waitForTrue(fn, maxRetries: number = 100, nFrequency: number = 100): Promise<void> {
        return new Promise<void>(async (resolve, reject) => {
            let retries: number = maxRetries || 100;
            do {
                if (fn()) break;
                await Util.wait(nFrequency || 100);
            } while (retries--);
            if (fn()) return resolve();
            return reject(new Error('waitForTrue expired unresolved'));
        });
    }

    public static globalExists(varName: string): boolean {
        let last = typeof (window as any) !== 'undefined' ? window : {} as Window;
        const parts: string[] = varName.split('.');
        for (let i = 0; i < parts.length; i++) {
            if (!last.hasOwnProperty(parts[i])) return false;
            last = last[parts[i]];
        }
        return true;
    }

    public static waitUntilGlobalExists(varName: string, maxRetries: number = 100, nFrequency: number = 100): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            Util.waitForTrue(() => { return Util.globalExists(varName); }, maxRetries, nFrequency)
                .then(() => { if (Util.globalExists(varName)) return resolve(); })
                .catch(() => { return reject('waitUntilGlobalExists(' + varName + ') expired unresolved'); })
        })
    }

    private static readonly _SAFARI_REGEXP: RegExp = /^((?!chrome|android|CriOS|FxiOS|YaBrowser).)*safari/i;
    public static isSafari(): boolean {
        const result: boolean = Util._SAFARI_REGEXP.test(navigator.userAgent);
        if (result) console.log('isSafari:' + result);
        return result;
    }

    public static getUrlParameter(name: string, url?: string): string {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) { return null; }
        if (!results[2]) { return ''; }
        return results[2];
    }

}
